module.exports = __webpack_public_path__ + "static/nills-sm-detail-5afd0691fbaac8159fd3754f423a4ccd.jpg";